import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Activity } from 'lucide-react';
import { teilnahmeAPI } from '@/lib/api';
import { SEGMENT, TREND, datumKurz, komma } from '@/components/teilnahme/teilnahmeText';

/* Kachel am Mitglied (v9 A, 23.10.2026): Besuche 4/12 Wochen, Ø je Woche, Trend, letzter Besuch, Verlauf über 12 Wochen.
   Octiv-Altdaten nur als Summe. Erscheint nur bei laufender Mitgliedschaft. */
export default function TeilnahmeKachel({ leadId }) {
  const [m, setM] = useState(null);
  useEffect(() => { setM(null); teilnahmeAPI.mitglied(leadId).then((r) => setM(r.data.mitglied)).catch(() => setM(null)); }, [leadId]);
  if (!m) return null;
  const seg = SEGMENT[m.segment] || SEGMENT.selten;
  const tr = TREND[m.trend] || TREND.gleich;
  const max = Math.max(1, ...m.verlauf.map((v) => v.besuche));
  return (
    <div className="rounded-xl border border-border/60 bg-card p-4 space-y-3" data-testid="teilnahme-kachel">
      <div className="flex items-center gap-2">
        <Activity className="w-4 h-4 text-muted-foreground" />
        <p className="text-sm font-semibold">Teilnahme</p>
        <span className={`ml-auto rounded-full px-2 py-0.5 text-[11px] font-semibold ${seg.klasse}`} title={seg.erklaerung}>{seg.text}</span>
      </div>
      <div className="grid grid-cols-4 gap-2 text-center">
        {[['4 Wochen', m.besuche_4w], ['12 Wochen', m.besuche_12w], ['Ø / Woche', komma(m.schnitt_woche)], ['letzter', datumKurz(m.letzter_besuch)]].map(([t, w]) => (
          <div key={t}><div className="text-lg font-bold tabular-nums">{w}</div><div className="text-[10px] text-muted-foreground">{t}</div></div>
        ))}
      </div>
      <div className="flex items-end gap-1 h-12" aria-label="Besuche je Woche über 12 Wochen" role="img">
        {m.verlauf.map((v) => (
          <div key={v.woche} className="flex-1 min-w-0 flex flex-col justify-end h-full" title={`Woche ab ${datumKurz(v.woche)}: ${v.besuche}`}>
            <div className={`rounded-t ${v.besuche ? 'bg-primary' : 'bg-muted'}`} style={{ height: `${v.besuche ? Math.max(12, (100 * v.besuche) / max) : 6}%` }} />
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">
        Trend <span className={`font-semibold ${tr.klasse}`}>{tr.zeichen}</span> {tr.text}
        {m.octiv_summe > 0 && <> · aus Octiv: {m.octiv_summe} Besuche gesamt</>}
        {' · '}<Link to="/teilnahme" className="hover:underline">alle Mitglieder</Link>
      </p>
    </div>
  );
}
